import React from 'react';

export const withStyledClasses = (WrappedComponent) => {
  const component = ({ className, displayName, hoffmannTheme, ...props }) => {
    return <WrappedComponent theme={hoffmannTheme} classNames={className.split(' ')} {...props} />;
  };
  component.displayName = 'withStyledClasses';
  return component;
};
